import { render, staticRenderFns } from "./base_token.vue.js?vue&type=template&id=0ae1eb4f!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_token.vue?vue&type=template&id=0ae1eb4f"
import script from "./base_token.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_token.vue?vue&type=script&lang=js"
export * from "./base_token.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae1eb4f')) {
      api.createRecord('0ae1eb4f', component.options)
    } else {
      api.reload('0ae1eb4f', component.options)
    }
    module.hot.accept("./base_token.vue.js?vue&type=template&id=0ae1eb4f!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./base_token.vue?vue&type=template&id=0ae1eb4f", function () {
      api.rerender('0ae1eb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/filtered_search_bar/tokens/base_token.vue"
export default component.exports